var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-2 py-4",staticStyle:{"min-height":"200px"},attrs:{"flat":""}},[(_vm.options.content)?_c('TipTapReader',{key:_vm.componentKey,staticClass:"tiptap_style",attrs:{"options":_vm.options}}):_c('div',{staticClass:"text-center font-weight-medium"},[_vm._v("입력 정보가 없습니다.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }